<template>
  <ModalContainer queryParam="code" ref="modalContainer">
    <b-card>
      <div class="mb-1">Codigo Validacion Issfa:</div>
      <b-form-input 
        v-model="codigoVal"
        type="text"
      />
      <div class="d-flex justify-content-end">
        <b-button
          variant="primary" 
          class="mt-2"
          @click="onSaveCode"
          :disabled="!codigoVal"
        >
          Guardar
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from "@/shared/components";
import { atencionMedicaService } from "../../services";

export default {

  name: "CodigoIssfa",

  components: {
    ModalContainer
  },


  data() {
    return {
      tokenAtencion: null,
      codigoVal: null
    }
  },


  created() {
    this.setTokenAtencion();
  },

  methods: {
    async setTokenAtencion() {
      this.tokenAtencion = this.$route.query.code;
      if(!this.tokenAtencion) return;
      const responseSearch = await atencionMedicaService.getByToken(this.tokenAtencion );
      if(responseSearch){
        this.codigoVal = responseSearch.cita.codderivacion;
      }
    },
    async onSaveCode() {
      const responseUpdate = await atencionMedicaService.updateByToken(this.tokenAtencion, { codderivacion: this.codigoVal });
      if(!responseUpdate) {
        await this.$swal({
          icon: 'error',
          title: 'No se pudo actualizar el codigo validacion ISSFA',
          showConfirmButton: true,
        });
        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Codigo Validacion Issfa actualizado',
        showConfirmButton: true,
      });

      await this.$refs.modalContainer.closeModal();
      this.$router.go();
    }
  },
  watch: {
    '$route.query.code': {
      handler() {
        this.setTokenAtencion();
      }
    }
  }
};
</script>
